import React from 'react';
import styled from 'styled-components'
import Icon from '@mdi/react';
import { mdiCheck } from '@mdi/js'
import Fade from 'react-reveal/Fade'

const Section = styled.div`
    padding: 5rem 2rem;
	background-color: #2c354a;
	color: #fff;
	flex-direction: column;
`;

const Title = styled.h2`
	font-size: 32px;
	text-align: center;
	margin-bottom: 4rem;
	
	@media (min-width: 768px) {
	    font-size: 48px;
	}
`;

const IconWrapper = styled.div`
    margin-right: 0.5rem;
`;

const List = styled.ul`
    max-width: 500px;
    margin: 0 auto;
	
	li {
	    display: flex;
	    align-items: flex-start;
	    line-height: 1.4;
	    margin-bottom: 1.5rem;
	    font-size: 18px;
	    
	    @media (min-width: 768px) {
            font-size: 22px;
        }
	    
	    svg {
	        width: 30px;
	    }
	}
`;

const Achievements = () => {
	return (
		<Section>
            <Fade duration={500} left>
                <Title>Achievements</Title>
            </Fade>
            <Fade duration={500} right cascade>
                <List>
                    <li><IconWrapper><Icon path={mdiCheck} /></IconWrapper> Founder of Compass Healing, highest rated Emotion/Body Code practice in the world</li>
                    <li><IconWrapper><Icon path={mdiCheck} /></IconWrapper> Co-Founder / Chief Healing Officer of Inside Out Institute</li>
                    <li><IconWrapper><Icon path={mdiCheck} /></IconWrapper> Creator of the most watched YouTube channel on the subject of the Emotion and Body Code</li>
                    <li><IconWrapper><Icon path={mdiCheck} /></IconWrapper> Nationally recognized speaker and lecturer</li>
                    <li><IconWrapper><Icon path={mdiCheck} /></IconWrapper> Creator of the Advanced Healer Success Guide</li>
                    <li><IconWrapper><Icon path={mdiCheck} /></IconWrapper> Founder of the "Healing the Healer" podcast</li>
                </List>
            </Fade>
		</Section>
	)
}

export default Achievements;
